import {
	axiosErrorHandler,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import {
	CurrentTileResponse,
	TileFilterDto,
	TileTracker,
	TileTrackerCreateDto,
	TileTrackerHistoryResponseDto,
	TileTrackerLocations,
	TileTrackerUpdateDto,
} from '../interfaces/tile.interface';

const baseTilePath = '/v1/tile-tracker';

export const fetchTiles = async (dto: TileFilterDto) => {
	try {
		const res = await get<PaginatedDocuments<TileTracker>>(
			buildPathWithQueryParams(baseTilePath, dto),
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchCurrentTile = async (vehicleId: string) => {
	try {
		const url = `${baseTilePath}/current/${vehicleId}`;
		const res = await get<CurrentTileResponse>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createTile = async (dto: TileTrackerCreateDto) => {
	try {
		const res = await post<TileTracker>(baseTilePath, dto);

		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateTile = async (values: TileTrackerUpdateDto, id: string) => {
	try {
		const res = await put<TileTracker>(`${baseTilePath}/${id}`, values);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const syncTiles = async () => {
	try {
		const res = await post<{ created: number }>(`${baseTilePath}/sync`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const removeTileVehicle = async (id: string) => {
	try {
		const res = await put<TileTracker>(`${baseTilePath}/${id}/removeVehicle`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchTilesLocations = async () => {
	try {
		const res = await get<TileTrackerLocations[]>(
			`${baseTilePath}/get-devices-locations`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
export const fetchTileLocation = async (id: string) => {
	try {
		const res = await get<TileTrackerLocations>(
			`${baseTilePath}/${id}/location`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchTilesLocationHistory = async (id: string) => {
	try {
		const res = await get<TileTrackerHistoryResponseDto>(
			`${baseTilePath}/${id}/history?days=90`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
